/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/shared/feedback/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(55);


/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var FeedbackFactory = window.FeedbackFactory = module.exports = {
	
	  version: ("2.7.9"),
	
	  options: {
	    sources: ".",
	    url: "feedback.php",
	    extraKey: "altKey",
	    key: 66
	  },
	
	  data: {},
	
	  scripts: [],
	
	  html2canvasOptions: {
	    //allowTaint: true,
	    letterRendering: true
	  },
	
	  setOption: function setOption(name, value) {
	    if (this.options.hasOwnProperty(name)) {
	      FeedbackFactory.options[name] = value;
	    } else {
	      console.error("\u041E\u043F\u0446\u0438\u044F \"" + name + "\" \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F");
	    }
	    return FeedbackFactory;
	  },
	  setOptions: function setOptions(options) {
	    for (var key in options) {
	      if (options.hasOwnProperty(key)) {
	        this.setOption(key, options[key]);
	      }
	    }
	    return FeedbackFactory;
	  },
	  setData: function setData(key, value) {
	    FeedbackFactory.data[key] = value;
	    return FeedbackFactory;
	  },
	  addScript: function addScript(url) {
	    FeedbackFactory.scripts.push(url);
	    return FeedbackFactory;
	  },
	  init: function init() {
	    var _this = this;
	
	    addEventListener('keydown', function (e) {
	      if (e[_this.options.extraKey] && e.keyCode == _this.options.key) {
	        FeedbackFactory.run();
	      }
	    });
	  },
	  run: function run() {
	    if (window.Feedback) {
	      init();
	      return;
	    }
	
	    var length = 0;
	
	    loadJS(FeedbackFactory.options.sources + '/feedback.js?v' + FeedbackFactory.version, done);
	    FeedbackFactory.scripts.forEach(function (url) {
	      loadJS(url, done);
	    });
	
	    function done() {
	      length--;
	      if (length === 0) {
	        init();
	      }
	    }
	
	    function loadJS(url, callback) {
	      length++;
	      var script = document.createElement('script');
	      script.onload = callback;
	      script.onerror = callback;
	      script.async = true;
	      script.src = url;
	      (document.head || document.body).appendChild(script);
	    }
	
	    function init() {
	      try {
	        Feedback.init({
	          options: FeedbackFactory.options,
	          html2canvasOptions: FeedbackFactory.html2canvasOptions,
	          data: FeedbackFactory.data
	        });
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  }
	};
	
	FeedbackFactory.init();

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** feedback.factory.js
 **/